import axios from "axios";

export const getNotifications = () => {
  return axios.get(`${process.env.VUE_APP_API_URL}/notifications`);
};
